import api from '@admin/api/service';
import { BASE_MAMIPAY_PATH } from './_mamipayBase';

export default {
  postAddTenant(payload) {
    return api.post(`${BASE_MAMIPAY_PATH}/tenant/add`, payload);
  },

  getTenantInfo(contractId) {
    return api.get(`${BASE_MAMIPAY_PATH}/contract/${contractId}/tenant`);
  },

  updateTenantInfo(contractId, data) {
    return api.patch(
      `${BASE_MAMIPAY_PATH}/contract/${contractId}/tenant`,
      data
    );
  },

  validateTenantPhoneNumber(contractId, phoneNumber) {
    return api.get(
      `${BASE_MAMIPAY_PATH}/contract/${contractId}/tenant/phone-validation?phone_number=${phoneNumber} `
    );
  },

  getTenantEditChangelog(contractId, page = 1) {
    return api.get(
      `${BASE_MAMIPAY_PATH}/contract/${contractId}/tenant/changelog?page=${page}`,
    );
  },
};
